function deleteQuery(query, { replace = false } = {}) {
	const url = new URL(window.location.href);
	url.searchParams.delete(query);
	replace ? history.replaceState({}, '', url) : history.pushState({}, '', url);
}

function resetQuery({ replace = false } = {}) {
	const url = new URL(window.location.href);
	url.search = '';
	replace ? history.replaceState({}, '', url) : history.pushState({}, '', url);
}

function updateQuery(query, value, { replace = false } = {}) {
	const url = new URL(window.location.href);
	url.searchParams.set(query, value);
	replace ? history.replaceState({}, '', url) : history.pushState({}, '', url);
}
